import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { Subscription } from 'rxjs';
import { delay } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { AuthService } from './services/auth/auth.service';
import { DeviceService } from './services/device/device.service';
import { LoaderService } from './services/loader/loader.service';

import { ModalService } from './services/modal/modal.service';
import { ParamsAligeService } from './services/params-alige/params-alige.service';
import { CampaignAnalyticsService, RedirectService, ScreenInitService } from './services';
import { AnalyticsService } from './services/analytics/analytics.service';

declare let cordova: any;


@Component({
   selector: 'mnf-app',
   templateUrl: './app.component.html',
   styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
   sub: Subscription;
   /**  */
   upd: Subscription;
   /** Booleano para abrir modal */
   loader: boolean;
   /** Token en caché para indicar que ya se aceptaron las cookies */
   stageCookieName = 'COOKIES';
   /** Token en caché de sesión inactiva para abrir modal */
   clsInv = 'SIN';
   /** En mobile por defeecto no sale modal para aceptar cookies */
   showWarningCookies = false;

   /** Mostrar screens de primera vez en una aplicación */
   showInitFirstTimeApp = true

   /** Detectar el tipo de plataforma */
   platformType: 'ios' | 'android' | 'web' = 'web';
   isNativePlatform: boolean = false;

   private readonly AUTO_LOGOUT = 'ALOO';

   constructor(
      private readonly _SwUpdate: SwUpdate,
      private readonly activatedRoute: ActivatedRoute,
      private readonly deviceServ: DeviceService,
      private readonly laoderServ: LoaderService,
      private readonly authServ: AuthService,
      private readonly modalSer: ModalService,
      private readonly _elementRef: ElementRef,
      private readonly paramsAlige: ParamsAligeService,
      private readonly router: Router,
      private readonly screenInitServ: ScreenInitService,
      private readonly analyticCampServ: CampaignAnalyticsService,
      private readonly analyticsService: AnalyticsService,
      public redirectServ: RedirectService
   ) {
      if (typeof cordova !== 'undefined') {
         this.platformType = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) ? 'ios' : 'android';
      } else {
        this.platformType = 'web';
        this.showInitFirstTimeApp = false;
      }
      this.analyticCampServ.captureAndStoreParams();
      this.analyticsService.setPlatformType(this.platformType);

   }

   updateApp() {
      document.location.reload();
   }

   hideWarningCookies() {
      localStorage.setItem(this.stageCookieName, '1');
      this.showWarningCookies = false;
   }

   checkUpdate() {
      if (this._SwUpdate.isEnabled) {
         this._SwUpdate.checkForUpdate().then(newVersion => {
            if (newVersion) {
               this._SwUpdate.activateUpdate().then((loaded) => {
                  if (loaded) {
                     window.location.reload();
                  }
               });
            }
         });
      }
   }

   ngOnInit() {
      this.isNativePlatform = this.platformType === 'ios' || this.platformType === 'android';

      if(this.isNativePlatform) {
         this.screenInitServ.checkIsFirstTime().then((getStorage: any) => {
            if(getStorage?.isFirstTime == 'false') {
               this.showInitFirstTimeApp = false;
            }
         })
      }

      this.checkUpdate();
      const c = localStorage.getItem(this.stageCookieName);

      if (environment.isMobile) {
         this.deviceServ.getNativeDevice();
      } else {
         if (!c) this.showWarningCookies = true;
      }

      this.checkInnactiveSession();

      if (environment.production) {
         caches?.keys().then((names) => {
            for (const name of names) caches?.delete(name);
         });
      }

      this.deviceServ.detectDevice();

      this.activatedRoute.queryParams.subscribe(params => {
         const referred = params.r || sessionStorage.getItem(this.authServ.REFERENCE_USER);
         const promoOrAnalytics = params.pr || sessionStorage.getItem(this.authServ.ANALYTIC_CODE);
         const fromLanding = params.l || sessionStorage.getItem(this.authServ.FROM_LANDING);
       
         const paramReferral = params.intrff;
         const storedData = localStorage.getItem(this.authServ.INTERNAL_REFERRAL);
       
         let storedReferral: string | null = null;
         let storedExpiry: number | null = null;
       
         if (storedData) {
           try {
             const parsed = JSON.parse(storedData);
             storedReferral = parsed.id;
             storedExpiry = parsed.expiresAt;
           } catch (e) {
             localStorage.removeItem(this.authServ.INTERNAL_REFERRAL);
           }
         }
       
         const now = Date.now();
       
         if (paramReferral && paramReferral.trim() !== '' && paramReferral !== storedReferral) {
           const expiresAt = now + 15 * 24 * 60 * 60 * 1000; // 15 días en ms
           localStorage.setItem(this.authServ.INTERNAL_REFERRAL, JSON.stringify({
             id: paramReferral,
             expiresAt
           }));
         } else if (!paramReferral && storedReferral && storedExpiry && now < storedExpiry) {
         } else if (storedReferral && storedExpiry && now >= storedExpiry) {
           localStorage.removeItem(this.authServ.INTERNAL_REFERRAL);
         }
       
         if (referred) {
           sessionStorage.setItem(this.authServ.REFERENCE_USER, referred);
         }
         if (promoOrAnalytics) {
           sessionStorage.setItem(this.authServ.ANALYTIC_CODE, promoOrAnalytics);
         }
         if (fromLanding) {
           sessionStorage.setItem(this.authServ.FROM_LANDING, '1');
         }
       });
       

      // Asignar parametros para Alige
      this.activatedRoute.queryParams.subscribe(params => {
        if(Object.keys(params).length > 0) {
          this.paramsAlige.setParams(params);
        }
      })

      this.checkAutoLogOut();

   }

   ngAfterViewInit() {
      this.sub = this.laoderServ.loader.pipe(delay(0)).subscribe(load => this.loader = load);
      this._elementRef.nativeElement.removeAttribute('ng-version');
   }

   checkAutoLogOut() {
      const autologout = sessionStorage.getItem(this.AUTO_LOGOUT);
      if (autologout && autologout === '1') {
         this.modalSer.modalCustom({
            img: 'https://static.monific.com/assets/assets-app/img/icon/img/attention.svg',
            title: 'Por seguridad',
            message: 'Tu sesión ha sido cerrada después de 5 minutos de inactividad para mantener la seguridad de tu cuenta. No te preocupes, puedes iniciar sesión de nuevo en cualquier momento. ¡Esperamos verte pronto!',
            buttonText: 'Aceptar',
         });

         sessionStorage.removeItem(this.AUTO_LOGOUT);
      }
   }

   checkInnactiveSession() {
      const s = localStorage.getItem(this.clsInv);
      if (s) {
         this.modalSer.modalCustom({
            img: 'https://static.monific.com/assets/assets-app/img/icon/img/attention.svg',
            title: 'Por seguridad',
            message: 'Tu sesión ha sido cerrada después de 5 minutos de inactividad para mantener la seguridad de tu cuenta. No te preocupes, puedes iniciar sesión de nuevo en cualquier momento para continuar donde lo dejaste. ¡Esperamos verte pronto!',
            buttonText: 'Aceptar',
         });

         localStorage.removeItem(this.clsInv);
      }
   }

   async firstTimeAppAction(show: { firstTimeApp: boolean, link: string }) {
      switch (show.link) {
         case 'register':
            this.showInitFirstTimeApp = false;
            if(this.isNativePlatform) {
               await this.screenInitServ.saveFirstTime().then((result) => {
                  this.router.navigate(['/registro']);
               })
            }
            break;
         case 'login':
            this.showInitFirstTimeApp = false;
            if(this.isNativePlatform) {
               await this.screenInitServ.saveFirstTime().then((result) => {
                  this.router.navigate(['/']);
               })
            }
            break;
         default:
            break;
      }
   }

   ngOnDestroy() {
      this.sub.unsubscribe();
      if (this.upd) this.upd.unsubscribe();
   }

}
